import { useState, useEffect, useRef, Fragment, useLayoutEffect } from "react";
import { InputGroup, FormGroup, Label, Input, Button } from "reactstrap";
import {useDispatch} from "react-redux";
import { cambiaruta } from "../../Slicersreducers";
import { Modal } from 'reactstrap';
import axios from "axios";

export const CreateViewAccount = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false)
  const getCookie = (name) => {
    let value = "; " + document.cookie;
    let parts = value.split("; " + name + "=");
    if (parts.length == 2) return parts.pop().split(";").shift();
  };
  const deleteAlert = (alert) => {
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };
  var createReactClass = require("create-react-class");
  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return  <div className="toast-bottom-right">{newsTemplate}</div>;
             
    },
  });
  const [listAlert, setListAlert] = useState([]);
  const [productData, setProductData] = useState({
    nombreDeCuenta: "",
    origenDeRecursos: "",
    cuentaEmbargable: "",
    exentaDeRetencion: "",
    requiereSupervision: "",
    nombreDeSupervisor: "",
    cargoDeSupervisor: "",
    nroIdentificacionSupervisor: "",
    nitEntidadSupervisor: "",
    tipoIdentificacion: getCookie("tid"),
    numeroDeIdentificacion: getCookie("nid"),
    correo: getCookie("email"),
  });

  // Estado inicial de validación
  const validationRules = {
    nombreDeCuenta: { required: true, message: "" },
    origenDeRecursos: { required: true, message: "" },
    cuentaEmbargable: { required: true, message: "" },
    exentaDeRetencion: { required: true, message: "" },
    requiereSupervision: { required: true, message: "" },
    nombreDeSupervisor: { required: false, message: "" },
    nroIdentificacionSupervisor: { required:false, message: "" },
    cargoDeSupervisor: { required: false, message: "" },
    nitEntidadSupervisor: { required: false, message: "" },
  };
  
  const [validation, setValidation] = useState(validationRules);

  const validateFields = () => {
    const newValidation = {};

    for (const field in validationRules) {
      const rules = validationRules[field];
      const value = productData[field];

      let isValid = true;
      let message = "";

      if ((rules.required && !value) || value === "0") {
        isValid = false;
        message = "Este campo es requerido";
      }

      if (isValid && rules.maxLength && value.length > rules.maxLength) {
        isValid = false;
        message = `No puede exceder el tamaño máximo de ${rules.maxLength} caracteres`;
      }

      if (isValid && rules.pattern && !rules.pattern.test(value)) {
        isValid = false;
        message = "El valor ingresado no es válido";
      }

      newValidation[field] = { isValid, message };
    }

    setValidation(newValidation);

    // Retorna false si alguno de los campos no es válido
    return !Object.values(newValidation).some((val) => !val.isValid);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "nroIdentificacionSupervisor" || name == 'nitEntidadSupervisor') {
      const onlyNumbers = value.replace(/\D/g, ""); // Elimina todo lo que no sea un número

      setProductData((prevState) => ({
        ...prevState,
        [name]:  onlyNumbers,
      }));
    } else {
      setProductData((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const storeProduct = async (productData, accessToken) => {
    debugger
    try {
      const response = await axios.post("/WSDinamyc/WSGYGR/home", {
        NombrePagina: "PIDEA045",
        InformacionRep: productData,
      },
      {
        headers: {
          Authorization: `Bearer ${accessToken.acces_token}`,
        },
      });
  
      if (response.status === 200) {
        if (response.data.respuestaWs){
          setProductData({
            nombreDeCuenta: "",
            origenDeRecursos: "",
            cuentaEmbargable: "",
            exentaDeRetencion: "",
            requiereSupervision: "",
            nombreDeSupervisor: "",
            cargoDeSupervisor: "",
            nroIdentificacionSupervisor: "",
            nitEntidadSupervisor: "",
            tipoIdentificacion: getCookie("tid"),
            numeroDeIdentificacion: getCookie("nid"),
            correo: getCookie("email"),
          })
          console.log(response)
          let respuestaExito = response.data.respuestaWs + " " + response.data.nroSolicitud
          setIsLoading(false)
          setListAlert([
            {
              description: respuestaExito,
              type: "alert alert-alert show alert-dismissible fade alert-success",
              icon: "fas fa-check-circle"
            },
          ])
        }
        else {
          setProductData({
            nombreDeCuenta: "",
            origenDeRecursos: "",
            cuentaEmbargable: "",
            exentaDeRetencion: "",
            requiereSupervision: "",
            nombreDeSupervisor: "",
            cargoDeSupervisor: "",
            nroIdentificacionSupervisor: "",
            nitEntidadSupervisor: "",
            tipoIdentificacion: getCookie("tid"),
            numeroDeIdentificacion: getCookie("nid"),
            correo: getCookie("email"),
          })
          console.log(response)
          setIsLoading(false)
          setListAlert([
            {
              description: "Error al crear cuenta vista",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            },
          ])
        }
      } else if(response.status === 401){
        let accessToken = await fetchToken();
        await storeProduct(productData, accessToken);
      }else{
        setIsLoading(false)
        setListAlert([
          {
            description: "Error al crear cuenta vista",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          },
        ])
      }
    } catch (error) {
      setIsLoading(false)
      console.log(error)
      let errors = error.response.data;
      let listaAlertas = []
      for (let i = 0; i < errors.length; i++){
          listaAlertas.push({
            description: errors[i].descripcion,
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          })
      }
      setListAlert(listaAlertas)
    }
  };

  const fetchToken = async () => {
    try {
        const response = await axios.post(
            '/WS_Ideatst/Seguridad/Autenticacion',
            {},
            {
                headers: {
                    username: 'WSIDE',
                    password: 'AMBIENTEIDE3',
                },
            }
        );
        if (response.status === 200) {
          return response.data;
      } else {
          return null;
      }
    } catch (error) {
        return null;
    }
};

  const handleSubmit = async() => {
    if (validateFields()) {
      setIsLoading(true)
      let accessToken = await fetchToken();
      if(accessToken){
        await storeProduct(productData, accessToken);
      }else{
        setIsLoading(false)
        setListAlert([
          {
            description: "Error por favor comunicarse con helpdesk.",
            type: "alert alert-alert show alert-dismissible fade alert-danger",
            icon: "fas fa-exclamation-circle",
          },
        ])
      }
    }
  };

  useEffect(() => {
    dispatch(cambiaruta("Inicio/Crear Producto/Crear cuenta vista"));
  }, []);
  return (
    <>
    <Alerts data={listAlert}></Alerts>
      <div class="pb-2 pt-3 pt-md-7 ml-lg-4 mr-lg-5">
        <div class="row justify-content-center">
          <div className="col-10">
            <h3>Crea cuenta vista</h3>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-2 col-xl-3"></div>
          <div class="col-lg-8 col-xl-6">
            <InputGroup className="input-group-alternative mt-3 mb-3">
              <div style={{ width: "100%" }}>
                <div className="inputs-icons-borderbott">
                  <input
                    maxLength={50}
                    className="form-control h5 p-1"
                    name="nombreDeCuenta"
                    placeholder="Nombre de la cuenta"
                    type="text"
                    value={productData.nombreDeCuenta}
                    onChange={handleInputChange}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "100%",
                      height: "25px",
                      padding: "0px 0px 0px 0px",
                      margin: "0px 0px 0px 0px",
                    }}
                  />
                </div>
              </div>
              {!validation.nombreDeCuenta.isValid && (
                <small style={{ color: "red" }}>
                  {validation.nombreDeCuenta.message}
                </small>
              )}
            </InputGroup>
            <InputGroup className="input-group-alternative mt-2 mb-3">
              <div
                className="inputs-icons-borderbott"
                //style={{ borderColor: isValid ? "black" : "red" }}
              >
                <select
                  id="selectField"
                  placeholder="Selecciona el origen de los recursos"
                  style={{
                    border: "none",
                    //color: isValid ? "black" : "red",
                    width: "100%",
                    fontSize: "14px",
                    height: "33px",
                  }}
                  name="origenDeRecursos"
                  value={productData.origenDeRecursos}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    Selecciona el origen de los recursos
                  </option>
                  <option value="1">Propios</option>
                  <option value="2">Departamento</option>
                  <option value="3">Entidad pública</option>
                  <option value="4">Entidad privada</option>
                </select>
              </div>
              {!validation.origenDeRecursos.isValid && (
                <small style={{ color: "red" }}>
                  {validation.origenDeRecursos.message}
                </small>
              )}
            </InputGroup>

            <InputGroup className="input-group-alternative mt-2 mb-3">
              <div
                className="inputs-icons-borderbott"
                //style={{ borderColor: isValid ? "black" : "red" }}
              >
                <select
                  id="selectField"
                  placeholder="¿Es cuenta embargable?"
                  style={{
                    border: "none",
                    //color: isValid ? "black" : "red",
                    width: "100%",
                    fontSize: "14px",
                    height: "33px",
                  }}
                  name="cuentaEmbargable"
                  value={productData.cuentaEmbargable}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    ¿Es cuenta embargable?
                  </option>
                  <option value="S">Si</option>
                  <option value="N">No</option>
                </select>
              </div>
              {!validation.cuentaEmbargable.isValid && (
                <small style={{ color: "red" }}>
                  {validation.cuentaEmbargable.message}
                </small>
              )}
            </InputGroup>

            <InputGroup className="input-group-alternative mt-2 mb-3">
              <div
                className="inputs-icons-borderbott"
                //style={{ borderColor: isValid ? "black" : "red" }}
              >
                <select
                  id="selectField"
                  placeholder="¿Es exenta de retención?"
                  style={{
                    border: "none",
                    //color: isValid ? "black" : "red",
                    width: "100%",
                    fontSize: "14px",
                    height: "33px",
                  }}
                  name="exentaDeRetencion"
                  value={productData.exentaDeRetencion}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    ¿Es exenta de retención?
                  </option>
                  <option value="S">Si</option>
                  <option value="N">No</option>
                </select>
              </div>
              {!validation.exentaDeRetencion.isValid && (
                <small style={{ color: "red" }}>
                  {validation.exentaDeRetencion.message}
                </small>
              )}
            </InputGroup>

            <InputGroup className="input-group-alternative mt-2 mb-3">
              <div
                className="inputs-icons-borderbott"
                //style={{ borderColor: isValid ? "black" : "red" }}
              >
                <select
                  id="selectField"
                  placeholder="¿Requiere supervisión?"
                  style={{
                    border: "none",
                    //color: isValid ? "black" : "red",
                    width: "100%",
                    fontSize: "14px",
                    height: "33px",
                  }}
                  name="requiereSupervision"
                  value={productData.requiereSupervision}
                  onChange={handleInputChange}
                >
                  <option value="" disabled selected>
                    ¿Requiere supervisión?
                  </option>
                  <option value="S">Si</option>
                  <option value="N">No</option>
                </select>
              </div>
              {!validation.requiereSupervision.isValid && (
                <small style={{ color: "red" }}>
                  {validation.requiereSupervision.message}
                </small>
              )}
            </InputGroup>
          </div>

          <div class="col-lg-2 col-xl-3"></div>
        </div>
        <div className="row justify-content-center">
          <div className="col-10">  
            <h3 className="m-0">Información supervisor</h3>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-md-5 col-sm-12">            
            <InputGroup className="input-group-alternative mt-3 mb-3">
              <div style={{ width: "100%" }}>
                <div className="inputs-icons-borderbott">
                  <input
                    maxLength={50}
                    className="form-control h5 p-1"
                    name="nombreDeSupervisor"
                    placeholder="Nombre supervisor"
                    type="text"
                    value={productData.nombreDeSupervisor}
                    onChange={handleInputChange}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "100%",
                      height: "25px",
                      padding: "0px 0px 0px 0px",
                      margin: "0px 0px 0px 0px",
                    }}
                  />
                </div>
              </div>
              {!validation.nombreDeSupervisor.isValid && (
                <small style={{ color: "red" }}>
                  {validation.nombreDeSupervisor.message}
                </small>
              )}
            </InputGroup>

            <InputGroup className="input-group-alternative mt-3 mb-3">
              <div style={{ width: "100%" }}>
                <div className="inputs-icons-borderbott">
                  <input
                    maxLength={21}
                    className="form-control h5 p-1"
                    name="nroIdentificacionSupervisor"
                    placeholder="Documento supervisor"
                    type="text"
                    value={productData.nroIdentificacionSupervisor}
                    onChange={handleInputChange}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "100%",
                      height: "25px",
                      padding: "0px 0px 0px 0px",
                      margin: "0px 0px 0px 0px",
                    }}
                  />
                </div>
              </div>
              {!validation.nroIdentificacionSupervisor.isValid && (
                <small style={{ color: "red" }}>
                  {validation.nroIdentificacionSupervisor.message}
                </small>
              )}
            </InputGroup>
          </div>

          <div className="col-md-5 col-sm-12">
            <InputGroup className="input-group-alternative mt-3 mb-3">
              <div style={{ width: "100%" }}>
                <div className="inputs-icons-borderbott">
                  <input
                    maxLength={50}
                    className="form-control h5 p-1"
                    name="cargoDeSupervisor"
                    placeholder="Cargo supervisor"
                    type="text"
                    value={productData.cargoDeSupervisor}
                    onChange={handleInputChange}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "100%",
                      height: "25px",
                      padding: "0px 0px 0px 0px",
                      margin: "0px 0px 0px 0px",
                    }}
                  />
                </div>
              </div>
              {!validation.cargoDeSupervisor.isValid && (
                <small style={{ color: "red" }}>
                  {validation.cargoDeSupervisor.message}
                </small>
              )}
            </InputGroup>

            <InputGroup className="input-group-alternative mt-3 mb-3">
              <div style={{ width: "100%" }}>
                <div className="inputs-icons-borderbott">
                  <input
                    maxLength={21}
                    className="form-control h5 p-1"
                    name="nitEntidadSupervisor"
                    placeholder="NIT Supervisor"
                    type="text"
                    value={productData.nitEntidadSupervisor}
                    onChange={handleInputChange}
                    style={{
                      fontSize: "14px",
                      border: "none",
                      width: "100%",
                      height: "25px",
                      padding: "0px 0px 0px 0px",
                      margin: "0px 0px 0px 0px",
                    }}
                  />
                </div>
              </div>
              {!validation.nitEntidadSupervisor.isValid && (
                <small style={{ color: "red" }}>
                  {validation.nitEntidadSupervisor.message}
                </small>
              )}
            </InputGroup>
          </div>
        </div>
        <button
              type="submit"
              className="bg-green text-white btn shadow btn-rounded btn-block mb-3 ml-auto mr-auto"
              style={{ width: "50%" }}
              onClick={handleSubmit}
            >
              Continuar
        </button>
        <Modal
          className="modal-dialog-centered"
          contentClassName="bg-transparent shadow-none"
          isOpen={isLoading}
        >
          <div
            tabIndex="-1"
            style={{
              position: "relative",
              zIndex: "1050",
              display: "block",
              width: "100%",
              height: "80vh"
            }}
          >
            <div
              style={{
                textAlign: "center",
                top: "50%",
                position: "relative"
              }}
            >
              <img
                style={{ height: "100px" }}
                src={require("../../assets/img/icons/LoaderIDEA.gif").default}
              ></img>
            </div>
            <div class="modal-backdrop fade show"></div>
          </div>
        </Modal>
      </div>
    </>
  );
};
